
export default function paginateResults(items = [], itemsPerPage = 0, currentPage = 1)
{
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return items.slice(startIndex, endIndex);
}